import * as yup from "yup";

export const corporateFormInputSchema = yup
  .object({
    name: yup
      .string()
      .required("Please enter your name 22")
      .min(4, "Please enter full name"),
    countryCode: yup.string().required().default("+91"),
    mobile: yup
      .string()
      .required("Please enter a valid phone number")
      .min(8, "Number should be minimum 8 characters")
      .max(14, "Number should be maximum 14 characters"),
    email: yup
      .string()
      .email("Please enter a valid email address")
      .required("Please enter a valid email address"),
    companyName: yup.string().required("Please enter a company name"),
  })
  .required();
